/**
 * @typedef {{key: string, replacesDocumentUploads?: boolean, slots: Object<string, import('react').ComponentType>}} ModuleDefinition
 * @param {Array<{default?: ModuleDefinition} | ModuleDefinition>} exports
 * @returns {ModuleDefinition[]}
 */
export function normalizeDefinitions(exports) {
  const seen = new Set();
  return exports.map((entry) => {
    const definition = entry?.default ?? entry;
    if (!/^[a-z][a-z0-9_-]*$/.test(definition?.key || '') || seen.has(definition.key)) {
      throw new Error('Invalid or duplicate optional module definition');
    }
    if (!definition.slots || Object.keys(definition.slots).some((slot) => (
      slot !== 'profile.verification.actions' || typeof definition.slots[slot] !== 'function'
    ))) {
      throw new Error('Invalid optional module slot');
    }
    seen.add(definition.key);
    return definition;
  });
}

export function normalizeEntitlements(payload) {
  return Array.isArray(payload?.items) ? payload.items.filter((item) => (
    typeof item?.key === 'string' && typeof item?.enabled === 'boolean'
  )).map(({ key, enabled }) => ({ key, enabled })) : [];
}
